export default {
    'title': 'Our Jobs',
    'subtitle': 'Discover them',
    'all_seasons': 'All',
    'details': 'More details',
    'no_jobs': 'There are no jobs at the moment'
}
